import { Component, ErrorInfo, ReactNode } from 'react';
import { logger } from '@/utils/logger';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.logError('React Error Boundary caught an error', {
      error: error.toString(),
      errorInfo: errorInfo.componentStack,
    });
  }

  private handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  public render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-screen bg-admin-bg">
          <div className="card max-w-md text-center">
            <h1 className="text-2xl font-bold text-red-600 mb-4">エラーが発生しました</h1>
            <p className="text-admin-textLight mb-6">
              申し訳ございません。予期しないエラーが発生しました。
            </p>
            {this.state.error && (
              <div className="bg-gray-100 p-4 rounded mb-6 text-left">
                <p className="text-sm text-gray-600 font-mono">
                  {this.state.error.toString()}
                </p>
              </div>
            )}
            <button onClick={this.handleReset} className="btn-primary">
              ダッシュボードに戻る
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
